import { th } from 'style/theme';
import styled, { css } from 'styled-components';
import { motion } from 'framer-motion';
import { sizes } from 'style';

export const TabsContainer = styled.ul.attrs({
  role: 'tablist',
  areaOrientation: 'horizontal'
})`
  padding: 0;
  display: flex;
  padding-top: 19px;
  padding-bottom: 19px;
  margin: 0;

  @media ${sizes.desktop} {
    margin-top: 9px;
    margin-bottom: 24px;
    padding: 0;
  }
`;

export const TabsWrapper = styled.div`
  grid-area: tabs;
  position: relative;
  overflow: scroll;
  width: 100%;
  padding-left: 16px;
  background: #4c6372;

  -ms-overflow-style: none;
  scrollbar-width: none;

  ::-webkit-scrollbar {
    display: none;
  }

  @media ${sizes.desktop} {
    padding-left: 36px;
    background: transparent;
  }
`;

export const TabWrapper = styled(motion.div)`
  display: flex;
  align-items: center;
  margin-right: 16px;
  transform: ${({ isActive }) => (isActive ? 'translatex(8px)' : 'translatex(0px)')};
  transition: 0.4s;

  > div {
    user-select: none;
    overflow: hidden;
    background: ${th('colors.black')};
    color: ${th('colors.white')};
    position: relative;
    left: -10px;
    border-top-right-radius: 8px;
    border-bottom-right-radius: 8px;
    font-weight: 700;
    font-size: 14px;

    > span {
      margin: 9px 8px 9px 20px;
      display: block;
      white-space: nowrap;
    }
  }
`;

export const StyledTab = styled.li`
  z-index: 1;
  border-radius: 50%;
  height: 56px;
  width: 56px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  list-style-type: none;
  background: ${th('colors.white')};
  transition: 0.5s;

  :last-child {
    margin-right: 0;
  }

  > svg {
    width: 28px;

    .st0 {
      fill: ${th('colors.transparentBlack.4')};
      transition: fill 0.2s;
    }
  }

  :hover > svg .st0 {
    fill: ${({ disabled, isActive }) => !disabled && !isActive && th('colors.black')};
  }

  ${({ isActive }) =>
    isActive &&
    css`
      background: ${th('colors.black')};
      transform: scale(1.15);

      @media ${sizes.desktop} {
        transform: scale(1.27);
      }

      > svg > .st0 {
        fill: ${th('colors.white')};
      }
    `};
`;

export const DisabledOverlay = styled.div`
  background-color: ${th('colors.transparentBlack.4')};
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  top: 0;
  left: 0;

  > svg {
    width: 12px;

    .st0 {
      fill: ${th('colors.white')};
    }
  }
`;
